<script lang="ts">
	import { Button } from '@atoms';
	import Chevron from '$lib/icons/Chevron.svelte';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import type { ServiceThumbType } from '@queries/GlobalQuery';

	const {
		services,
		onHover
	}: {
		onHover?: (service: ServiceThumbType) => void;
		services: ServiceThumbType[];
	} = $props();
</script>

{#each services as service, i}
	<span class="btn" use:EnterOnView={{ delay: i * 0.02 }}>
		<Button
			onmouseenter={() => onHover?.(service)}
			class="text:description"
			variant="link"
			href={'/ydelser/' + service.slug}
		>
			<span class="icon">
				<Chevron></Chevron>
			</span>
			{service.service}
		</Button>
	</span>
{/each}

<style lang="scss">
	.icon {
		margin-right: 30px;
		transition: transform 0.2s;
	}
	.btn {
		display: grid;
		:global([data-button]) {
			border-bottom: $border;
			padding: $padding-mini 0;
			text-decoration: none;
			&:hover {
				text-decoration: none;
			}
		}

		:global([data-button]:hover .icon) {
			transform: translateX(8px);
			transition-duration: 0s;
		}
	}
</style>
